export const state = {
    loading: false,    
}

export const mutations = {
    SET_LOADING(state, payload) {
        state.loading = payload
    },    
}

export const actions = { 
    changeLoading({ commit }, status) {
        commit('SET_LOADING', status)        
    },
}